import React, { Component } from 'react'
import ValuesRecharge from './ValuesRecharge'
import { PhoneNumber } from '../../../CellphoneRecharge/PhoneNumber'
import { Button, Checkbox } from 'loyal-react'
import PropTypes from 'prop-types'
import { ModalTerms } from '../../../CellphoneRecharge/ModalTerms'
import constants from '../../../CellphoneRecharge/constants'

class FormStep extends Component {
  constructor (props) {
    super(props)
    this.onChangeService = this.onChangeService.bind(this)
    this.onChangeAreaCode = this.onChangeAreaCode.bind(this)
    this.onChangePhoneNumber = this.onChangePhoneNumber.bind(this)
    this.btnMobileRechargeClick = this.btnMobileRechargeClick.bind(this)
    this.onChageAcceptTerms = this.onChageAcceptTerms.bind(this)
    this.state = {}
  }

  onChageAcceptTerms (e) {
    this.setState({
      acceptTerms: e.target.checked
    })
  }

  onChangeAreaCode (e) {
    this.setState({
      serviceId: '',
      pointsValue: '',
      rechargeValue: ''
    })
  }
  onChangePhoneNumber (e) {
    this.setState({
      areaCode: e.value,
      phoneNumber: e.phoneNumber
    })
  }

  onChangeService (e) {
    this.setState({
      serviceId: e.value,
      pointsValue: e.pointsValue,
      rechargeValue: e.rechargeValue
    })
  }

  btnMobileRechargeClick () {
    if (this.state.acceptTerms) {
      this.props.insertMobileRecharge(
        this.state.serviceId,
        this.props.operatorKey,
        this.state.areaCode,
        this.state.phoneNumber
      )
    } else {
      this.setState({
        showTerms: true
      })
    }
  }
  render () {
    let style = this.props.visible ? {} : { display: 'none' }
    return (
      <div
        style={style}
        className='bg-white radius row px-1 mx-0 pt-2 pb-1 border-top-lg border-color-featured'
      >
        <div className='row px-1 mx-0'>
          <div className='col-10'>
            <p className='txt-body-sm my-1'>
              Faça sua recarga {this.props.operatorKey}.
            </p>
          </div>
          <div className='col-2 pl-3'>
            <i
              className='icon icon_close txt-body-sm cursor'
              onClick={this.props.backStep}
            />
          </div>
          <PhoneNumber
            operatorKey={this.props.operatorKey}
            areaCode={this.state.areaCode}
            phoneNumber={this.state.phoneNumber}
            divContentClassName='col-12 col-md-12 mt-12 form-field mt-1'
            onChangePhoneNumber={this.onChangePhoneNumber}
            onChangeAreaCode={this.onChangeAreaCode}
            disabled={false}
          />
          <ValuesRecharge
            id='rechargeValue'
            label='Valor da Recarga'
            className='col-12 mt-2 form-field'
            operatorKey={this.props.operatorKey}
            areaCode={this.state.areaCode}
            onChangeValue={this.onChangeService}
            serviceId={this.state.serviceId}
          />
          <div className='col-12 row mx-0'>
            <Checkbox
              id='aceito_termos_recharge'
              className='col-auto'
              labelClass='l-0'
              checked={this.state.acceptTerms}
              onChange={this.onChageAcceptTerms}
            />
            <div className='col-10 col-md-auto pt-2'>
              <p className='txt-body-sm'>
                Li e aceito os{' '}
                <a
                  className='txt-body-sm color-brand-1'
                  role='button'
                  onClick={e => this.setState({ showTerms: true })}
                >
                  termos do regulamento
                </a>
              </p>
            </div>
          </div>
          <div className='col-12 pb-1'>
            <Button
              id={'btnMobileRecharge'}
              name={'DoneRecharge'}
              className='btn-featured btn btn-sm'
              text='Finalizar Recarga'
              loading={this.props.loadingFinalizeOrder}
              onClick={this.btnMobileRechargeClick}
              disabled={
                !(
                  this.props.operatorKey &&
                  this.state.areaCode &&
                  this.state.acceptTerms &&
                  (this.state.phoneNumber &&
                    this.state.phoneNumber.indexOf('_') === -1 &&
                    this.state.phoneNumber.length === 10) &&
                  this.state.serviceId
                )
              }
            />
          </div>
        </div>
        <ModalTerms
          show={this.state.showTerms}
          onClose={e => this.setState({ showTerms: false })}
          acceptTerms={e => {
            this.setState({
              showTerms: false,
              acceptTerms: true
            })
          }}
          terms={{
            vendorId: constants.VENDORID_CELLPHONE_RECHARGE,
            type: constants.REGULATION_TYPE_VENDOR
          }}
        />
      </div>
    )
  }
}

FormStep.propTypes = {
  operatorKey: PropTypes.string,
  insertMobileRecharge: PropTypes.func,
  loadingFinalizeOrder: PropTypes.bool,
  backStep: PropTypes.func,
  visible: PropTypes.bool
}

export default FormStep



// WEBPACK FOOTER //
// ./src/features/Services/RechargePhone/FormStep/FormStep.js